import React from 'react';

import { PartnerSlot, UsefulToolsTitle } from 'components/Ads';
import styles from './UsefulTools.scss';

const USEFUL_TOOLS_SLOTS = [1, 2, 3, 4, 5, 6];

function UsefulTools() {
  return (
    <div className={styles.usefulToolsContainer}>
      <div className="usefulTools">
        <UsefulToolsTitle
          id="gpt_7294_tools_and_services_header"
          adUnitLevel3="yourvaluation"
        />
        <div className={styles.cardsGrid}>
          {USEFUL_TOOLS_SLOTS.map(slot => (
            <PartnerSlot
              key={slot}
              id={`gpt_7294_tools_and_services${slot}`}
              number={slot}
              adUnitLevel3="yourvaluation"
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default UsefulTools;



// WEBPACK FOOTER //
// ./src/components/UsefulTools/UsefulTools.js